// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2bExG","info":"UpdateTermsInfo_info__1JlWO"};